// extracted by mini-css-extract-plugin
export default {"root":"IconFile_root__0DGIo","pencil":"IconFile_pencil__wx8bb"};